import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import moment from 'moment';
import { GetCustomerById } from '../API/CustomerAPI';
import AWS from 'aws-sdk'
import { toast } from 'react-toastify';

const S3_BUCKET = process.env.REACT_APP_INVOICE_S3_BUCKET;
const REGION = process.env.REACT_APP_REGION;

AWS.config.update({
    accessKeyId: process.env.REACT_APP_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_SCRET_KEY
})

const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
})

const DownloadInvoice = ({ downloadDraft, setDownloadDraft, downloadInvoiceData, setDownloadInvoiceData }) => {
    const [customer, setCustomer] = useState('')
    const [loader, setLoader] = useState(false)
    const printRef = useRef();

    const handleDownloadPdf = async () => {
        setLoader(true)
        const element = printRef.current;
        const canvas = await html2canvas(element);
        const data = canvas.toDataURL('image/png');

        const pdf = new jsPDF();
        const imgProperties = pdf.getImageProperties(data);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
        pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);

        // Upload pdf to AWS S3
        const str = JSON.stringify(pdf)
        var myBlob = new Blob([str], { type: 'application/pdf' })

        const params = {
            ACL: 'public-read',
            Body: JSON.stringify(pdf),
            Bucket: S3_BUCKET,
            Key: `${downloadInvoiceData.customer_id}/${downloadInvoiceData.invoice_items_id}.pdf`
        };

        myBucket.putObject(params)
            .on('httpUploadProgress', (evt) => {
                console.log('Upload...', Math.round((evt.loaded / evt.total) * 100))
            })
            .send((err) => {
                if (err) toast.error(err.message, { autoClose: 5000 });
            })

        pdf.save(`invoice-${downloadInvoiceData.invoice_items_id}.pdf`);
        setDownloadInvoiceData('')
        setDownloadDraft(false)
        setLoader(false)
    };

    const getCustomerData = async () => {
        if (downloadInvoiceData !== '') {
            const result = await GetCustomerById(downloadInvoiceData.customer_id)
            setCustomer(result)
        }
    }

    useEffect(() => {
        getCustomerData()
    }, [downloadInvoiceData])


    return (
        <div>
            <Transition.Root show={downloadDraft} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setDownloadDraft}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c1c9d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm">
                                    <div className='p-[20px]'>
                                        <div className="text-[#414552]">
                                            <div className="font-semibold text-[#1a1b25] text-base">Download draft invoice</div>
                                            <p className="text-[14px] mt-1">Are you sure you want to download this draft invoice?</p>
                                        </div>
                                        <div className="flex justify-end gap-2 mt-2">
                                            <button className="border-[1px] h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px] flex items-center gap-2" onClick={() => { setDownloadDraft(false); setDownloadInvoiceData('') }}>Cancel</button>
                                            {loader ? <button className="border-[2px] h-[30px] rounded-[8px] bg-[#625afa] border-[#625afa] text-[14px] font-semibold p-[0_8px] flex items-center gap-2 text-white leading-[30px]" disabled>Loading...</button>
                                                : <button className="border-[2px] h-[30px] rounded-[8px] bg-[#625afa] border-[#625afa] text-[14px] font-semibold p-[0_8px] flex items-center gap-2 text-white leading-[30px]" onClick={handleDownloadPdf}>Download draft</button>}
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            {(downloadInvoiceData !== '' && downloadDraft) && <div className='mt-[20px] p-[50px]' ref={printRef}>
                <div className='flex justify-between items-center'>
                    <h1 className='text-[40px] font-[600] text-black'>Invoice</h1>
                    <p className='text-[#9b9b9b] text-[40px] font-[500]'>abc</p>
                </div>
                <div className='text-[22px] font-[500] mt-[14px]'>
                    <div className='flex text-black'>
                        <p className='w-[200px] font-[600]'>Invoice number</p>
                        <p className='font-[600]'>{downloadInvoiceData.invoice_items_id}</p>
                    </div>
                    <div className='flex text-black'>
                        <p className='w-[200px]'>Date Due</p>
                        <p>{moment(Date()).format("MMMM DD, yyyy")}</p>
                    </div>
                </div>
                <div className='mt-[18px] text-[22px] flex text-black'>
                    <p className='w-[45%] font-[600]'>abc</p>
                    <div className='w-[55%]'>
                        <p className='font-[600]'>Bill to</p>
                        <p>{customer.name}</p>
                        <p>{customer.account_email}</p>
                    </div>
                </div>
                <h1 className='text-[22px] font-[500] my-[20px] text-black'>
                    ${downloadInvoiceData.price * (downloadInvoiceData.qty ? downloadInvoiceData.qty : 1)} {moment(Date()).format("MMMM DD, yyyy")}</h1>
                <table className='w-full text-[22px] text-black'>
                    <thead>
                        <th className='text-start font-normal border-b-[1px] border-b-[#aaa] pb-[10px] w-[674px]'>Description</th>
                        <th className='text-start font-normal border-b-[1px] border-b-[#aaa] pb-[10px]'>Qty</th>
                        <th className='text-start font-normal border-b-[1px] border-b-[#aaa] pb-[10px]'>Unit prize</th>
                        <th className='text-end font-normal border-b-[1px] border-b-[#aaa] pb-[10px]'>Amount</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='text-start font-normal py-1 pb-[20px]'>{downloadInvoiceData.item}</td>
                            <td className='text-start font-normal py-1 pb-[20px] border-b-[1px] border-b-[#aaa3]'>{downloadInvoiceData.qty}</td>
                            <td className='text-start font-normal py-1 pb-[20px] border-b-[1px] border-b-[#aaa3]'>{downloadInvoiceData.price}</td>
                            <td className='text-end font-normal py-1 pb-[20px] border-b-[1px] border-b-[#aaa3]'>${downloadInvoiceData.price * (downloadInvoiceData.qty ? downloadInvoiceData.qty : 1)}</td>
                        </tr>
                        <tr>
                            <td className='py-2'></td>
                            <td className='py-2 border-b-[1px] border-b-[#aaa3]'>Subtotal</td>
                            <td className='py-2 border-b-[1px] border-b-[#aaa3]'></td>
                            <td className='text-end py-2 border-b-[1px] border-b-[#aaa3]'>${downloadInvoiceData.price * (downloadInvoiceData.qty ? downloadInvoiceData.qty : 1)}</td>
                        </tr>
                        <tr>
                            <td className='py-2'></td>
                            <td className='py-2 border-b-[1px] border-b-[#aaa3]'>Total</td>
                            <td className='py-2 border-b-[1px] border-b-[#aaa3]'></td>
                            <td className='text-end py-2 border-b-[1px] border-b-[#aaa3]'>${downloadInvoiceData.price * (downloadInvoiceData.qty ? downloadInvoiceData.qty : 1)}</td>
                        </tr>
                        <tr>
                            <td className='py-2'></td>
                            <td className='font-[600] py-2'>Amount due</td>
                            <td className='py-2'></td>
                            <td className='text-end font-[600] py-2'>${downloadInvoiceData.price * (downloadInvoiceData.qty ? downloadInvoiceData.qty : 1)}</td>
                        </tr>
                    </tbody>
                </table>
                <p className='pt-[20px] text-black border-t-[1px] border-t-[#aaa3] text-[22px] mt-[1500px] mb-[60px]'>{downloadInvoiceData.invoice_items_id} -
                    ${downloadInvoiceData.price * (downloadInvoiceData.qty ? downloadInvoiceData.qty : 1)} {moment(Date()).format("MMMM DD, yyyy")}</p>
            </div>}

        </div>
    )
}

export default DownloadInvoice